import { DomainFormValidationSchema } from '@/modules/Domains/domains.interfaces';

export const domainFormValidationSchema: DomainFormValidationSchema = {
  names: [],
  registratedAt: [
    { required: true, message: 'Введіть дату реєстрації домену' },
    {
      type: 'date',
      message: 'Дата має бути валідною'
    }
  ],
  paidAt: [
    { required: true, message: 'Введіть дату оплати домену' },
    {
      type: 'date',
      message: 'Дата має бути валідною'
    }
  ],
  domainRegistrarId: [{ required: true, message: 'Виберіть реєстратор домену' }, { type: 'string' }],
  domainRegistrarAccountId: [{ required: true, message: 'Виберіть акаунт реєстратора домену' }, { type: 'string' }]
};
